<div class="containers">
  <div class="selection-tools-box">
    <h2>Selection</h2>
    <div class="info-line">
      <span> Selected area{{ selectionToolService.nbOfElementsSelected$() > 1 ? 's' : '' }}</span>
      <span>{{ selectionToolService.nbOfElementsSelected$() }}</span>
    </div>

    <div class="info-line">
      <span>Surface area</span>
      <span
        >{{ selectionToolService.selectedSurface$() | number: '1.0-2' | numberformat }} km<sup
          >2</sup
        ></span
      >
    </div>
    <div class="info-line">
      <span>Scale</span>
      <span
        >{{ selectionScaleService.currentScaleLevel$()?.displayName }}
        {{
          selectionScaleService.currentScaleLevel$()?.info
            ? '(' + selectionScaleService.currentScaleLevel$()?.info + ')'
            : ''
        }}</span
      >
    </div>
  </div>
</div>
